<template>
  <base-material-card
    color="bgAlert"
    icon="mdi-alert"
    inline
    class="px-5 py-3"
  >
    <template v-slot:after-heading>
      <div class="display-2 font-weight-light text-start v-card--material__heading mb-n6 v-sheet theme--dark elevation-6 bgAlert pa-7">
        {{ title }}
      </div>
    </template>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
        />
      </v-col>
    </v-row>

    <v-divider class="mt-3" />

    <v-data-table
      :headers="localizationHeaders"
      :items="items"
      :search.sync="search"
      :sort-by="['name']"
      :sort-desc="[false]"
      :loading="loading"
    >
      <template v-slot:top>
          <v-spacer />
          <v-btn
            class="float-button"
            elevation="1"
            color="btnFloatColor"
            dark
            fab
            min-width="0"
            small
            @click="addAlert"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
      </template>
      <template v-slot:item.name="{ item }">
        <v-btn
          color="success"
          class="px-1 ml-1"
          fab
          x-small
        >
          <v-icon @click="editItem(item)">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.active="{ item }">
        {{ booleanFormat(item.active) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          color="success"
          class="px-1 ml-1"
          fab
          x-small
        >
          <v-icon @click="editItem(item.id)">
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
    <alert-crud
      :show="showEditDialog"
      :target-alert-id="targetAlertId"
      :target-device-id="targetDeviceId"
      :method="dialogMethod"
      :alert-type="alertType"
      @change-edit-dialog="changeEditDialog"
    />
  </base-material-card>
</template>
<style>
.float-button{
  float: right;
}
.bgAlert{
  background-color: #023A66 !important;
}
</style>
<script>
  import filters from '@/common/filters'
  import { repositoryFactory } from '@/api/repositoryFactory'
  import AlertCrud from './Alert'
  const targetAlertsRespository = repositoryFactory.get('targetAlerts')

  export default {
    name: 'TargetAlerts',
    components: { AlertCrud },
    mixins: [filters],
    props: {
      targetDeviceId: {
        type: String,
        required: true,
      },
      alertType: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      showEditDialog: false,
      dialogMethod: 'edit',
      targetAlertId: null,
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
    }),
    computed: {
      title: {
        get () {
          return this.$t('targetAlerts')
        },
      },
      localizationHeaders () {
        return [
          {
            text: this.$t('tables.targetAlerts.description'),
            value: 'description',
          },
          {
            text: this.$t('tables.targetAlerts.active'),
            value: 'active',
          },
          {
            text: this.$t('tables.targetAlerts.periodicity'),
            value: 'periodicity',
          },
          {
            sortable: false,
            text: this.$t('actions'),
            value: 'actions',
          },
        ]
      },
    },
    mounted () {
      this.fetchData()
    },
    methods: {
      fetchData () {
        var self = this
        self.loading = true
        targetAlertsRespository.getTargetAlertsByTargetDevice(self.targetDeviceId).then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.showErrorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      addAlert () {
        this.dialogMethod = 'add'
        this.showEditDialog = true
      },
      editItem (id) {
        this.dialogMethod = 'edit'
        this.targetAlertId = id
        this.showEditDialog = true
      },
      changeEditDialog () {
        this.showEditDialog = false
        this.fetchData()
      },
    },
  }
</script>
